import Loader from '../loader/Loader';
import styles from './waitingMessage.module.scss';

interface IWaitingMessageProps {
  display: Display;
}
function WaitingMessage({ display }: IWaitingMessageProps) {
  if (display !== 'waiting') return null;

  return (
    <div className={styles.waitingMessage}>
      <h3>Modifications en cours</h3>

      <Loader size={150} thickness={15} />

      <p>Vous serez ridirigé sur urbanease une fois la modification effectuée</p>
    </div>
  );
}

export default WaitingMessage;
